"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const CatalogMobileSubLinks_1 = require("@Components/CatalogMobileSubLinks");
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const PaginationResultsBlock_1 = __importDefault(require("@App/kit/components/PaginationResultsBlock"));
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const DeleteDraftModal_1 = __importDefault(require("@Components/CreateWorkBottomNavs/DeleteDraftModal"));
const RegistrationDraftsContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationDrafts/RegistrationDraftsContentHeader"));
const RegistrationDraftsTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationDrafts/RegistrationDraftsTable"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const limitItems = 10;
const RightsholderCatalogRegistrationDrafts = () => {
    const { workStore, rightsholderStore, workSearchStore, uiStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [deleteAllPopupOpen, setDeleteAllPopupOpen] = (0, react_1.useState)(false);
    const [deleteIndividualPopupOpen, setDeleteIndividualPopupOpen] = (0, react_1.useState)(false);
    const [deletedTitle, setDeletedTitle] = (0, react_1.useState)();
    const [deletedId, setDeletedId] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const openDeleteModal = (typeAll, title, id) => {
        if (typeAll) {
            setDeleteAllPopupOpen(true);
        }
        else {
            setDeletedTitle(title);
            setDeletedId(id);
            setDeleteIndividualPopupOpen(true);
        }
    };
    const closeDeleteModal = () => {
        if (deleteAllPopupOpen) {
            setDeleteAllPopupOpen(false);
        }
        else {
            setDeleteIndividualPopupOpen(false);
        }
    };
    const eventGetWorksDrafts = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (pagination = {
        page: 1,
        limit: limitItems,
    }) {
        setLoading(true);
        yield workSearchStore.getWorksDraftsRightsHolder(rightsholderStore.currentRightsholderId, pagination);
        setLoading(false);
    });
    const handleDeleteAllDrafts = () => __awaiter(void 0, void 0, void 0, function* () {
        yield workStore.deleteAllDraftsRightsHolder(rightsholderStore.currentRightsholderId);
        closeDeleteModal();
        yield eventGetWorksDrafts();
    });
    const handleDeleteDraft = (deleteThisId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!deleteThisId) {
            return;
        }
        yield workStore.deleteDraftRightsHolder(deleteThisId);
        closeDeleteModal();
        yield eventGetWorksDrafts();
    });
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_registration_drafts');
        eventGetWorksDrafts().then();
        return () => {
            workSearchStore.destroyWorksDraftsRightsHolderPaginationInfo();
        };
    }, []);
    const isMobile = uiStore.isMobile;
    const workDrafts = workSearchStore.worksDraftsRightsHolder;
    const paginationPages = workSearchStore.worksDraftsRightsHolderPaginationInfo;
    const numTitles = workDrafts && paginationPages && (0, get_num_titles_1.getNumTitles)(workDrafts.count, paginationPages.currentPage, limitItems);
    const isInternal = userStore.isInternal;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Registration Drafts' }),
        react_1.default.createElement("div", { className: 'rightsholder-catalog-drafts-wrapper' },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'Registration Drafts', descriptionElement: react_1.default.createElement(RegistrationDraftsContentHeader_1.default, null) }),
                react_1.default.createElement("div", { className: 'info-text' },
                    react_1.default.createElement("p", { className: 'bold' },
                        "You have",
                        ' ',
                        !workDrafts || workDrafts.count === 0
                            ? 'no works'
                            : workDrafts.count === 1
                                ? '1 work'
                                : `${workDrafts.count} works`,
                        ' ',
                        "saved for later")),
                isMobile && react_1.default.createElement(CatalogMobileSubLinks_1.CatalogMobileSubLinks, null),
                react_1.default.createElement("section", { className: 'showing-search' },
                    react_1.default.createElement(PaginationResultsBlock_1.default, { totalResults: (workDrafts === null || workDrafts === void 0 ? void 0 : workDrafts.count) ? workDrafts.count : 0, workNumTitles: numTitles }),
                    react_1.default.createElement("a", { className: 'link bold delete-all', onClick: () => openDeleteModal(true) }, "Delete All")),
                loading ? react_1.default.createElement(PointPreloader_1.default, null) : react_1.default.createElement(RegistrationDraftsTable_1.default, { openDeleteModal: openDeleteModal }),
                workDrafts && workDrafts.count > limitItems && (react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: paginationPages, onChange: eventGetWorksDrafts })))),
        react_1.default.createElement(DeleteDraftModal_1.default, { open: deleteAllPopupOpen || deleteIndividualPopupOpen, closeModal: closeDeleteModal, title: deletedTitle, individual: !deleteAllPopupOpen, handleDeleteDraft: () => (deleteAllPopupOpen ? handleDeleteAllDrafts() : handleDeleteDraft(deletedId)), disabled: isInternal })));
};
exports.default = (0, mobx_react_1.observer)(RightsholderCatalogRegistrationDrafts);
